module.exports = __webpack_public_path__ + "static/59ab25cd-3a1f-4399-81fa-2439011bb13f-0b702864dd8c3a4f6a80e71358c0db42.webp";